/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	// パラメータ格納関数
	const pArray = () => {
		let urlParam = location.search.substring(1);
		let paramArray = [];
		if(urlParam) {
			let param = urlParam.split('&');
			for(let i = 0; i < param.length; i++) {
				let paramItem = param[i].split('=');
				paramArray[paramItem[0]] = paramItem[1];
			}
		}
		return paramArray;
	};
	// 製品検索のエリアの設定
	const setProductSearch = () => {

		// プルダウンの設定
		const setPulldown = () => {
			const pulldown = $('.js-businessList');
			const getJSONpulldown = () => {
				let JSONURL = ''
				const pagePath = location.pathname;
				if (pagePath.indexOf('/ja/') != -1) {
					JSONURL = '/ja/ajax/product/search/business.json';
				}else if (pagePath.indexOf('/en/') != -1) {
					JSONURL = '/en/ajax/product/search/business.json';
				}
				return $.getJSON(JSONURL);
			};
			let thisTagName = pulldown.attr('name');
			pulldown.css('pointer-events', 'none');
			if (location.pathname.indexOf('/ja/') != -1) {
				pulldown.append($('<option>').html('選択してください').val(''));
			}else if (location.pathname.indexOf('/en/') != -1) {
				pulldown.append($('<option>').html('Please select').val(''));
			}
			getJSONpulldown().then((data) => {
				// console.log(data,'getJSONpulldowntheme');
				for(let i = 0; i < data.rt_bn_business_list.length; i++) {
					if(!(pArray()[thisTagName] === data.rt_bn_business_list[i]._key)) {
						if (location.pathname.indexOf('/ja/') != -1) {
							pulldown.append($('<option>').html(data.rt_bn_business_list[i].cf_bu_name_jp).val(data.rt_bn_business_list[i]._key));
						}else if (location.pathname.indexOf('/en/') != -1) {
							pulldown.append($('<option>').html(data.rt_bn_business_list[i].cf_bu_name_en).val(data.rt_bn_business_list[i]._key));
						}
					} else {
						if (location.pathname.indexOf('/ja/') != -1) {
							pulldown.append($('<option>').html(data.rt_bn_business_list[i].cf_bu_name_jp).val(data.rt_bn_business_list[i]._key).prop('selected', true));
						}else if (location.pathname.indexOf('/en/') != -1) {
							pulldown.append($('<option>').html(data.rt_bn_business_list[i].cf_bu_name_en).val(data.rt_bn_business_list[i]._key).prop('selected', true));
						}
					}
				}
				pulldown.css('pointer-events', 'auto');
			});
		}
		// submit時の処理
		const submitSearch = (elem) => {
			let searchinputVal = elem.parents('.inc_products_search_full').find('.js-search-keyword').val().replaceAll(/[\"]/g,"").replaceAll(/[\']/g,"");
			elem.parents('.inc_products_search_full').find('.js-search-keyword').val(searchinputVal);
			let kewords = searchinputVal.replaceAll("　", " ").split(/\s/);
			let keywordInputs;
			for(let i = 0; i < kewords.length; i++) {
				if(i == 0) {
					keywordInputs = '<input name="p_keyword_1" type="hidden" value="'+kewords[i]+'" />';
					 elem.parents('form').append(keywordInputs);
				} else if(i == 1) {
					keywordInputs = '<input name="p_keyword_2" type="hidden" value="'+kewords[i]+'" />';
					 elem.parents('form').append(keywordInputs);
				} else if(i == 2) {
					keywordInputs = '<input name="p_keyword_3" type="hidden" value="'+kewords[i]+'" />';
					 elem.parents('form').append(keywordInputs);
				} else if(i == 3) {
					keywordInputs = '<input name="p_keyword_4" type="hidden" value="'+kewords[i]+'" />';
					 elem.parents('form').append(keywordInputs);
				} else if(i == 4) {
					keywordInputs = '<input name="p_keyword_5" type="hidden" value="'+kewords[i]+'" />';
					 elem.parents('form').append(keywordInputs);
				}
			}
			elem.parents('form').submit();
		}
		$('.js-search-submit').on('click', function(){
			submitSearch($(this))
		});
		$('.js-search-keyword').keypress(function(e){
			if (e.keyCode == 13) {
				submitSearch($(this))
			}
		});
		// 検索条件をクリア
		$('.js-search-clear').on('click', function(){
			$(this).parents('.inc_products_search_full').find('.js-search-keyword').val('');
			$(this).parents('.inc_products_search_full').find('.js-businessList').val('');
			$("input[name='p_usage']").prop("checked", false).change();
		});

		setPulldown();
	}

	// 特集製品のタグを生成する
	// ファイル：/ja/product/index.html
	const setPickupProductTag = () => {
		const setPickupProductTagID = () => {
			const IDElem = $('.rt_cf_p_key');
			let IDArr = new Array();
			for (let j = 0; j < IDElem.length; j++) {
				IDArr.push(IDElem.eq(j).text())
			}
			return IDArr;
		}
		const setPickupProductTagJSON = (num) => {
			let JSONURL = ''
			const pagePath = location.pathname;
			if (pagePath.indexOf('/ja/') != -1) {
				JSONURL = '/ajax/ja/product/pickup/'+pickupProductID[num]+'.json';
			}else if (pagePath.indexOf('/en/') != -1) {
				JSONURL = '/ajax/en/product/pickup/'+pickupProductID[num]+'.json';
			}
			return $.getJSON(JSONURL);
		}
		const setBttomTag = (itemData , num) => {
			const tagList = newsBox.eq(num).find('.product-results-item-tag_list')
			tagList.empty();
			let tagElem = ""
			if (itemData.cf_p_usage !== null) {						
				for (let j = 0; j < itemData.cf_p_usage.length; j++) {
					if (location.pathname.indexOf('/ja/') != -1) {
						tagElem += '<p class="_tag">'+ itemData.cf_p_usage[j].cf_u_name_jp +'</p>'
					}else if (location.pathname.indexOf('/en/') != -1) {
						tagElem += '<p class="_tag">'+ itemData.cf_p_usage[j].cf_u_name_en +'</p>'
					}

				}
			}
			tagList.append(tagElem)
			
		}
		const setDepartmentName = (itemData , num) => {
			const departmentName = newsBox.eq(num).find('._department')
			if (location.pathname.indexOf('/ja/') != -1) {
				departmentName.text(itemData.cf_p_business.cf_bu_name_jp);
			}else if (location.pathname.indexOf('/en/') != -1) {
				departmentName.text(itemData.cf_p_business.cf_bu_name_en);
			}
		}
		const generatPickupProductItem = () => {
			for (let i = 0; i < pickupProductID.length; i++) {
				setPickupProductTagJSON(i).then((data) => {
					setBttomTag(data.rt_bn_product_pickup_product[0] , i)
					setDepartmentName(data.rt_bn_product_pickup_product[0] , i)
				})
			}
		}
		const pickupProductID = setPickupProductTagID()
		const newsBox = $('.mod-news_box')
		generatPickupProductItem()
	}

	// 製品群を生成
	// 製品群があるファイル
	// /ja/product/business/template_block.html
	// /ja/product/business/template_blockLink.html
	// /ja/product/business/template_product.html
	// /ja/product/business/template_product_lineup.html
	const setProductGroup = () => {
		const getJSONProductGroup = (pathName ,ID) => {
			const JSONURL = pathName + ID + '.json';
			return $.getJSON(JSONURL);
		}
		const productGroup = $('.rt_bn_productgroup_list')
		for (let j = 0; j < productGroup.length; j++) {
			let id = null;
			let path = "";
			if (productGroup.eq(j).children('span').hasClass('rt_cf_p_group_code')) {
				id = productGroup.eq(j).children('.rt_cf_p_group_code').text()
				const pagePath = location.pathname;
				if (pagePath.indexOf('/ja/') != -1) {
					path = '/ajax/ja/product/business/productgroup/';
				}else if (pagePath.indexOf('/en/') != -1) {
					path = '/ajax/en/product/business/productgroup/';
				}
			}else if (productGroup.eq(j).children('span').hasClass('rt_cf_p_group_code_lineup')){
				id = productGroup.eq(j).children('.rt_cf_p_group_code_lineup').text()
				const pagePath = location.pathname;
				if (pagePath.indexOf('/ja/') != -1) {
					path = '/ajax/ja/product/product/productgroup/';
				}else if (pagePath.indexOf('/en/') != -1) {
					path = '/ajax/en/product/product/productgroup/';
				}
			}
			if (id !== null) {
				getJSONProductGroup(path,id).then((data) => {
					const ProductList = productGroup.eq(j).children('.product-results-list')
					const MoreBtn = productGroup.eq(j).children('.mod-button')
					const dataArr = data.rt_bn_product_list
					let itemElem = new Array(dataArr.length);
					// 説明文
					const getLeadElem = (num) => {
						let newsTitleElem = ''
						if (dataArr[num].rt_cf_p_overview_text !== null) {
							console.log(dataArr[num].rt_cf_p_overview_text);
							for (let k = 0; k < dataArr[num].rt_cf_p_overview_text.content.length; k++) {
								if (dataArr[num].rt_cf_p_overview_text.content[k].tag === 'br') {
									newsTitleElem += '<br>';
								}else if (dataArr[num].rt_cf_p_overview_text.content[k].tag) {
									newsTitleElem += '<'+ dataArr[num].rt_cf_p_overview_text.content[k].tag +'>';
									newsTitleElem += dataArr[num].rt_cf_p_overview_text.content[k].content;
									newsTitleElem += '</'+ dataArr[num].rt_cf_p_overview_text.content[k].tag +'>';
								} else {
									newsTitleElem += dataArr[num].rt_cf_p_overview_text.content[k];
								}
							}
						}
						console.log(newsTitleElem);
						return newsTitleElem;
					}
					//タグ部の生成
					const getTagElem = (num) => {
						let newsTagElemElem = ''
						if (dataArr[num].cf_p_usage !== null) {
							for (let k = 0; k < dataArr[num].cf_p_usage.length; k++) {
								newsTagElemElem += '<p class="_tag">'+ dataArr[num].cf_p_usage[k].rt_cf_p_usage.content[0] +'</p>';					
							}
						}
						return newsTagElemElem;
					}
					// hrefのデータを取得（undefindを""に置き換える）
					const getHrefData = (data) => {
						let dataArr = new Array(4)
						dataArr[0] = data.href
						const key = ['target' , 'class' , 'style']
						for (let i = 1; i < dataArr.length; i++) {
							if (data[key[i-1]]) {
								dataArr[i] = data[key[i-1]]
							} else {
								dataArr[i] = ""
							}
						}
						return dataArr
					}
					for (let i = 0; i < dataArr.length; i++) {
						itemElem[i] = ''
						itemElem[i] += '<li class="pure-u-1-3 pure-u-lg-1-1 space-u-30-child js-product-results-item">'
						const hrefData = getHrefData(dataArr[i].rt_cf_p_href)
						itemElem[i] += '<a href="' + hrefData[0] + '" target="' + hrefData[1] + '" class="' + hrefData[2] + '" style="'+ hrefData[3] +'">'
						itemElem[i] += '<div class="product-results-item">'
						itemElem[i] += '<div class="product-results-item-img">'
						itemElem[i] += '<img src="'+dataArr[i].rt_cf_p_main_image.src+'" alt="'+dataArr[i].rt_cf_p_main_image.alt+'" class="_img">'
						itemElem[i] += '</div>'
						itemElem[i] += '<div class="product-results-item-desc">'
						for (let k = 0; k < dataArr[i].rt_cf_p_business.content.length; k++) {
							itemElem[i] += '<p class="_department">'+dataArr[i].rt_cf_p_business.content[k]+'</p>'
						}
						if (location.pathname.indexOf('/ja/') != -1) {
							itemElem[i] += '<h3 class="_product">'+dataArr[i].cf_p_name_jp+'</h3>'
						}else if (location.pathname.indexOf('/en/') != -1) {
							itemElem[i] += '<h3 class="_product">'+dataArr[i].cf_p_name_en+'</h3>'
						}
						itemElem[i] += '<p class="_lead">'+ getLeadElem(i) +'</p>'
						itemElem[i] += '<ul class="product-results-item-tag_list">'
						itemElem[i] += getTagElem(i)
						itemElem[i] += '</ul>'
						itemElem[i] += '</div>'
						itemElem[i] += '</div>'
						itemElem[i] += '</a>'
						itemElem[i] += '</li>'
					}
					ProductList.empty();
					if (itemElem.length > 3) {
						for (let i = 0; i < itemElem.length; i++) {
							ProductList.append(itemElem[i])
						}
						MoreBtn.on('click', function(){
							MoreBtn.css('display' , 'none')
							ProductList.children('.js-product-results-item').css('display' , 'block')
						})
					}else {
						for (let i = 0; i < itemElem.length; i++) {
							ProductList.append(itemElem[i])
						}
						MoreBtn.css('display', 'none')
					}
				})
			}
		}
	}
	// ページトップにある製品群のリンク
	// ページトップにある製品群のリンクがあるファイル
	// /ja/product/business/template_block.html
	// /ja/product/business/template_blockLink.html
	const setProductGroupLink = () => {
		const getJSON = (ID) => {
			let JSONURL = ''
			const pagePath = location.pathname;
			if (pagePath.indexOf('/ja/') != -1) {
				JSONURL = '/ajax/ja/product/business/productgroup/link/' + ID + '.json';
			}else if (pagePath.indexOf('/en/') != -1) {
				JSONURL = '/ajax/en/product/business/productgroup/link/' + ID + '.json';
			}
			return $.getJSON(JSONURL);
		}
		const getHerfTarget = (data) => {
			if (data) {
				return data
			}else {
				return ""
			}
		}
		const productGroup = $('.rt_bn_productgroup_link_list')
		for (let j = 0; j < productGroup.length; j++) {
			if (productGroup.eq(j).children('span').hasClass('rt_cf_p_group_code')) {
				const id = productGroup.eq(j).children('.rt_cf_p_group_code').text()
				productGroup.eq(j).css('pointer-events','none')
				getJSON(id).then((data) => {
					const ProductList = productGroup.eq(j).children('.product-business_link-item-list')
					const dataArr = data.rt_bn_product_list
					let itemElem = new Array(dataArr.length);
					for (let i = 0; i < dataArr.length; i++) {
						itemElem[i] = ''
						if (location.pathname.indexOf('/ja/') != -1) {
							itemElem[i] += '<li><a href="'+ dataArr[i].rt_cf_p_href.href +'"target="' + getHerfTarget(dataArr[i].rt_cf_p_href.target) + '"><h3>'+dataArr[i].cf_p_name_jp+'</h3></a></li>'
						}else if (location.pathname.indexOf('/en/') != -1) {
							itemElem[i] += '<li><a href="'+ dataArr[i].rt_cf_p_href.href +'"target="' + getHerfTarget(dataArr[i].rt_cf_p_href.target) + '"><h3>'+dataArr[i].cf_p_name_en+'</h3></a></li>'
						}
					}
					ProductList.empty();
					for (let i = 0; i < itemElem.length; i++) {
						ProductList.append(itemElem[i])
					}
					productGroup.eq(j).css('pointer-events','auto')
				})
			}
		}
	}
	// 製品ページのタブ内の内容が空の場合はタブごと非表示にする
	// 製品ページのタブがあるファイル
	// /ja/product/business/template_product.html
	// /ja/product/business/template_product_lineup.html
	const displayProductTab = () => {
		const productTab = $('.js-product-menu_tab')
		const productTabBlock = $('.js-product-menu_tab-block')
		const hideProductTab = (num) => {
			productTabBlock.eq(num).css('display', 'none')
			productTab.eq(num).css('display', 'none')
			productTab.eq(num + 4).css('display', 'none')
		}
		const setCurrent = () => {
			for (let i = 0; i < productTabBlock.length; i++) {
				if (productTab.eq(i).css("display") !== 'none') {
					productTabBlock.eq(i).removeClass('di_none')
					productTab.eq(i).addClass('current')
					productTab.eq(i + 4).addClass('current')	
					break;
				}
			}
		}
		for (let i = 0; i < productTabBlock.length; i++) {
			let hideFlag = true;
			const productTabBlockElem = productTabBlock.eq(i)
			productTabBlockElem.addClass('di_none')

			if (productTabBlockElem.children('p').length !== 0) {
				hideFlag = false
			}
			const blockClassName = ".rt_cf_n_block_link_"+ (i + 2) +"_type_is_0"
			if (productTabBlockElem.find(blockClassName).length !== 0) {					
				if (productTabBlockElem.find(blockClassName).children().length !== 0) {
					hideFlag = false
				}
			}
			const blockLinkClassName = ".rt_cf_n_block_link_"+ (i + 2) +"_type_is_1"
			if (productTabBlockElem.find(blockLinkClassName).length !== 0) {					
				if (productTabBlockElem.find(blockLinkClassName).children().length !== 0) {
					hideFlag = false
				}
			}
			if (i === 3) {					
				if(productTabBlockElem.find('.rt_bn_productgroup_list').length !== 0){
					hideFlag = false
				}
			}
			if(hideFlag) {
				hideProductTab(i)
			}
		}
		setCurrent()
	}
	// 関連リンクが無い場合はエリアごと非表示にする
	// 関連リンクがあるファイル
	// /ja/product/business/template_product.html
	// /ja/product/business/template_product_lineup.html
	const displayRelatedLink = () => {
		if ($('.product-link_area-item').length === 0) {
			$('.product-link_area').parents('section').css('display', 'none')
		}
	}
	// 問い合わせボタンのURLにラインナップ製品名をセットする。
	// 対象のファイル
	// /ja/product/business/template_product_lineup.html
	const setContactLinkURL = () => {
		const lineupName = $('h1').text()
		const contactLinkBtn = $('.js-product_lineup_contact')
		const setContactLinkURLJSON = (idArr) => {
			let JSONURL = ''
			const pagePath = location.pathname;
			if (pagePath.indexOf('/ja/') != -1) {
				JSONURL = '/ajax/ja/product/lineup/inquiry_href/'+idArr[0]+'/'+idArr[1]+'.json?p_lineup_name='+lineupName;
			}else if (pagePath.indexOf('/en/') != -1) {
				JSONURL = '/ajax/en/product/lineup/inquiry_href/'+idArr[0]+'/'+idArr[1]+'.json?p_lineup_name='+lineupName;
			}
			return $.getJSON(JSONURL);
		}
		const getID = () => {
			return location.pathname.split('/').slice(-3)
		}
		if (contactLinkBtn.length !== 0) {
			const idArr = getID()
			setContactLinkURLJSON(idArr).then((data) => {
				contactLinkBtn.attr('href',data.rt_bn_product_for_inquiry_href[0].rt_inquiry_href.href)
			})
		}
	}
	const setSearchViewMore = () => {
		const numOfView = 12;
		let currentView = 0;
		const $resultsItem = $('.js-results-item')
		const $btn = $('.js-view_more_btn')

		const doViewMore = () => {
			if (currentView + numOfView >= $resultsItem.length) {
				for (let i = currentView; i < $resultsItem.length; i++) {
					$resultsItem.eq(i).css('display' , 'block')
					$btn.css('display' , 'none')
				}
			}else {
				for (let i = currentView; i < currentView + numOfView; i++) {
					$resultsItem.eq(i).css('display' , 'block')
				}
				currentView += numOfView
			}
		}
		doViewMore()
		$btn.on('click', function(){
			doViewMore()
		})
	}

	setProductSearch()
	setProductGroupLink()
	setProductGroup()
	setPickupProductTag()
	displayProductTab()
	displayRelatedLink()
	setContactLinkURL()
	setSearchViewMore()

})(window.jQuery, window.FUNCTIONS);